// ============================================================
// types/nomina.types.ts — Nómina de Matrícula
// ============================================================

export type EstadoNomina = 'GENERADA' | 'APROBADA' | 'ENVIADA_UGEL' | 'RECTIFICADA';

export interface GenerarNominaPayload {
  gradoId: number;
  seccionId: number;
  anioEscolarId: number;
  usuarioId: number;
}

export interface AprobarNominaPayload {
  directorId: number;
  observaciones?: string;
}

export interface NominaResponse {
  idNomina: number;
  gradoId: number;
  gradoNombre: string;
  gradoNivel: string;
  seccionId: number;
  seccionNombre: string;
  anioEscolarId: number;
  anio: number;
  estado: EstadoNomina;
  totalMatriculados: number;
  generadoPorId: number;
  generadoPorNombre: string;
  aprobadoPorId: number | null;
  aprobadoPorNombre: string | null;
  fechaGeneracion: string;
  fechaAprobacion: string | null;
  fechaEnvio: string | null;
  observaciones: string | null;
}

export const ESTADO_NOMINA_LABEL: Record<EstadoNomina, string> = {
  GENERADA: 'Generada',
  APROBADA: 'Aprobada',
  ENVIADA_UGEL: 'Enviada a UGEL',
  RECTIFICADA: 'Rectificada',
};

export const ESTADO_NOMINA_COLOR: Record<EstadoNomina, string> = {
  GENERADA:     'bg-blue-100 text-blue-700',
  APROBADA:     'bg-green-100 text-green-700',
  ENVIADA_UGEL: 'bg-purple-100 text-purple-700',
  RECTIFICADA:  'bg-amber-100 text-amber-700',
};
